import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { requireAppCheck } from '@jfw/angular/shared/app-check';
import { PLATFORM_DP_ENVIRONMENT } from '@jfw/angular/shared/tokens';
import {
  PriceInquiry,
  PriceInquiryResult,
  RetailPriceInquiryResult,
} from '@jfw/types';
import { catchError, map, Observable, of } from 'rxjs';

type PriceInquiryResponse = {
  success: boolean;
  data: PriceInquiryResult[];
};

type RetailPriceInquiryResponse = {
  success: boolean;
  data: RetailPriceInquiryResult[];
};

@Injectable({
  providedIn: 'root',
})
export class WholesalePricingService {
  private readonly http = inject(HttpClient);
  private readonly environment = inject(PLATFORM_DP_ENVIRONMENT);
  private readonly apiUrl = this.environment.wholesale_pricing_api_url;

  private readonly reqHeader = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  public submitPriceInquiry(
    request: PriceInquiry,
  ): Observable<PriceInquiryResponse> {
    return this.http
      .post<PriceInquiryResult[]>(`${this.apiUrl}/price-inquiry`, request, {
        ...requireAppCheck,
        headers: this.reqHeader,
      })
      .pipe(
        map((response) => {
          const data = response.map((item) => {
            item.productId = item.productId.trim();
            item.styleCode = item.styleCode.trim();
            return item;
          });
          return {
            success: true,
            data,
          };
        }),
        catchError((error) => {
          console.error(error);
          return of({ success: false, data: [] });
        }),
      );
  }

  public submitRetailPriceInquiry(
    request: PriceInquiry,
  ): Observable<RetailPriceInquiryResponse> {
    return this.http
      .post<RetailPriceInquiryResult[]>(
        `${this.apiUrl}/retail-price-inquiry`,
        request,
        {
          ...requireAppCheck,
          headers: this.reqHeader,
        },
      )
      .pipe(
        map((response) => {
          const data = response.map((item) => {
            item.productId = item.productId.trim();
            item.style = item.style.trim();
            return item;
          });
          return {
            success: true,
            data,
          };
        }),
        catchError((error) => {
          console.error(error);
          return of({ success: false, data: [] });
        }),
      );
  }
}
